import { css } from 'styled-components';
export default css(["display:inline-block;.tab-link{cursor:", ";opacity:", ";margin-right:10px;outline:none;}&.bar{margin-right:10px;}&.bar:after{content:'|';position:relative;top:-2px;}.tab-link:focus-visible{outline:2px solid black;border-radius:2px;}"], function (props) {
  return props.isSelected ? "default" : "pointer";
}, function (props) {
  return props.isSelected ? "1" : "0.5";
});